module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Fatal-Vows-3.6ea5294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Fatal-Vows-3.jpg
// module id = Mfjl
// module chunks = 0